import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Box, Button, Container, IconButton, Stack, Toolbar, Tooltip } from '@mui/material';
import { LoginOutlined } from '@mui/icons-material';
import { useLanguage } from '../../contexts/LanguageContext';
import LanguageSwitcher from '../common/LanguageSwitcher';
import ThemeSwitcher from '../common/ThemeSwitcher';
import BrandLockup from '../brand/BrandLockup';

const PublicHeader: React.FC = () => {
  const { t } = useLanguage();
  return <AppBar position="static" color="transparent" elevation={0} sx={{ borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
    <Container maxWidth="lg">
      <Toolbar disableGutters sx={{ minHeight: { xs: 72, md: 84 }, gap: 1 }}>
        <Box component={RouterLink} to="/" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1.25, color: 'text.primary', textDecoration: 'none', flexShrink: 0 }}>
          <BrandLockup markSize={42} fontSize="clamp(1.3rem, 2vw, 1.65rem)" gap={.75} />
        </Box>
        <Stack component="nav" direction="row" spacing={.5} aria-label={t('landing.learnMore')} sx={{ ml: { xs: 'auto', md: 5 }, display: { xs: 'none', md: 'flex' } }}>
          <Button component={RouterLink} to="/help" color="inherit">{t('nav.help')}</Button>
        </Stack>
        <Stack direction="row" spacing={{ xs: 0, sm: .75 }} alignItems="center" sx={{ ml: 'auto' }}>
          <LanguageSwitcher />
          <ThemeSwitcher />
          <Tooltip title={t('landing.login')}><IconButton component={RouterLink} to="/login" aria-label={t('landing.login')} sx={{ display: { xs: 'inline-flex', sm: 'none' } }}><LoginOutlined /></IconButton></Tooltip>
          <Button component={RouterLink} to="/login" variant="text" sx={{ display: { xs: 'none', sm: 'inline-flex' } }}>{t('landing.login')}</Button>
          <Button component={RouterLink} to="/register" variant="contained" size="small" sx={{ whiteSpace: 'nowrap', px: { xs: 1.25, sm: 2 } }}>{t('landing.getStarted')}</Button>
        </Stack>
      </Toolbar>
    </Container>
  </AppBar>;
};

export default PublicHeader;
